import { useMemo } from 'react'

import dynamicRepo from '@/repository/dynamicRepo'
import serviceRepo from '@/repository/service.repo'
import type { ClassT } from '@/types/utilityTypes'

const useSetRepository = <T extends ClassT>(
  identifier: [T, string] | T,
  ...param: ConstructorParameters<T>
) =>
  useMemo(() => {
    if (Array.isArray(identifier)) {
      return dynamicRepo.set(identifier, ...param)
    }
    return serviceRepo.set(identifier, ...param)
  }, [])

export default useSetRepository
